import * as React from "react";
import {useState} from "react";
import {
    TextField,
    SelectField,
    CardActions,
    Show,
    DateField,
    EditButton
} from 'react-admin';
import {
    Button,
    Card,
    CardContent,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText
} from '@material-ui/core';

import DocumentArrayField from "../component/DocumentArrayField";
import PhoneArrayField from "../component/PhoneArrayField";
import SpecialitiesArrayField from "../component/SpecialitiesArrayField";
import EducationArrayField from "../component/EducationArrayField";
import QualificationArrayField from "../component/QualificationArrayField";
import PartyVerificationDeathButton from "../component/PartyVerificationDeathButton";
import VerificationArrayField from "../component/VerificationArrayField";

const EmployeeActions = ({ data }) => {
    const [alertOpen, setAlertOpen] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [loading, setLoading] = useState(false);

    const popupAlert = (message) => {
        setAlertOpen(true);
        setAlertText(message);
    };

    const handleAlertClose = () => {
        setAlertOpen(false);
    };

    const sendRequest = (body) => {
        setLoading(true);

        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Basic ' + process.env.REACT_APP_API_TOKEN,
                'X-Session': localStorage.getItem('session')
            },
            body: JSON.stringify(body)
        };

        fetch(
            process.env.REACT_APP_API_ENTRYPOINT + '/employees/' + body.id + '/save-id',
            requestOptions
        )
            .then(response => {
                if (response.status >= 400) {
                    return Promise.reject();
                }

                return response.json()
            })
            .then(data => {
                if (data.id) {
                    popupAlert('ID актуалізовано.');
                } else {
                    popupAlert('Помилка завантаження даних.');
                }

                setLoading(false);
            })
            .catch(() => {popupAlert('Помилка надсилання запиту.'); setLoading(false);});
    };

    const saveId = () => {
        sendRequest({
            id: data.id,
            email: data.party.email
        });
    };

    return (
        <CardActions>
            <Button color={"primary"} onClick={saveId}>Актуалізувати ID</Button>
            {
                typeof data !== 'undefined'
                && data.status === 'APPROVED'
                && data.employeeType !== 'OWNER'
                ? <EditButton record={data} label={"Редагувати"} /> : null
            }

            <Dialog
                open={alertOpen}
                onClose={handleAlertClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-content">{alertText}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAlertClose} variant="contained" color="primary">OK</Button>
                </DialogActions>
            </Dialog>
        </CardActions>
    )
};

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 200,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const error = {
    width: 1000,
    fontWeight: 500,
    color: 'red',
    fontSize: '1.00rem'
};

const Label = (prop) => {
    return (
        <span style={labelStyle}>{prop.caption}: </span>
    );
}

const LocalEntityGrid = ({record}) => (
    <div style={{ margin: '1em' }}>
            <div className="legal-entity-list-show">
                <Card style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Загальна інформація</Typography>
                    <CardContent style={rowStyle}>
                        <Label caption={"Юридична особа"}/>
                         <TextField className="employee-show-item" label="Юридична особа" source="legalEntity.name" />
                    </CardContent>
                         <CardContent style={rowStyle}>
                        <Label caption={"Аптека"}/>
                         <TextField  className="employee-show-item" label="Аптека" source="division.name" />
                        </CardContent>
                         <CardContent style={rowStyle}>
                        <Label caption={"Посада співробітника"}/>
                         <SelectField className="employee-show-item" label="Посада співробітника" source="position" choices={[
                             {id: 'P222' , name: 'Лаборант (фармація)'},
                             {id: 'P21' , name: 'Провізор'},
                             {id: 'P217' , name: 'Провізор клінічний'},
                             {id: 'P218' , name: 'Провізор-аналітик'},
                             {id: 'P219' , name: 'Провізор-гомеопат'},
                             {id: 'P223' , name: 'Провізор-інтерн'},
                             {id: 'P220' , name: 'Провізор-косметолог'},
                             {id: 'P221' , name: 'Провізор-токсиколог'},
                             {id: 'P16' , name: 'Фармацевт'},
                             {id: 'P20' , name: 'Старший провізор'},
                             {id: 'P14' , name: 'Спеціаліст відділу кадрів'}
                         ]} />
                            </CardContent>
                         <CardContent style={rowStyle}>
                        <Label caption={"Тип посади"}/>
                         <SelectField className="employee-show-item" label="Тип посади" source="employeeType" choices={[
                            { id: 'ADMIN', name: 'Адміністратор'},
                            { id: 'ASSISTANT', name: 'Асистент'},
                            { id: 'DOCTOR', name: 'Лікар'},
                            { id: 'HR', name: 'Відділ кадрів'},
                            { id: 'NHS ADMIN', name: 'Адміністратор адмін панелі НСЗУ'},
                            { id: 'NHS ADMIN MONITORING', name: 'Виконуючий функції моніторингу'},
                            { id: 'NHS ADMIN PROGRAM MEDICATION', name: 'Виконуючий функції адміністрування медичних програм'},
                            { id: 'NHS ADMIN REIMBURSEMENT', name: 'Виконуючий функції адміністрування електронних рецептів'},
                            { id: 'NHS ADMIN SIGNER', name: 'Виконуючий функції контрактування'},
                            { id: 'NHS ADMIN VERIFIER', name: 'Виконуючий функції верифікації'},
                            { id: 'NHS LE TERMINATOR', name: 'Виконуючий функцію деактивації закладу'},
                            { id: 'NHS LE VERIFIER', name: 'Виконуючий функції верифікації юридичних осіб'},
                            { id: 'OWNER', name: 'Керівник закладу ОЗ'},
                            { id: 'PHARMACIST', name: 'Фармацевт'},
                            { id: 'PHARMACY_OWNER', name: 'Керівник аптеки'},
                            { id: 'RECEPTIONIST', name: 'Працівник реєстратури'},
                            { id: 'SPECIALIST', name: 'Спеціаліст'}
                        ]} />
                    </CardContent>
                </Card>
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Особиста інформація</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Прізвище"}/>
                            <TextField className="employee-show-item"  label="Прізвище" source="party.lastName" />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Ім'я"}/>
                            <TextField className="employee-show-item"  label="Ім'я" source="party.firstName" />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"По батькові"}/>
                            <TextField className="employee-show-item"  label="По батькові" source="party.secondName" />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Стать"}/>
                            <SelectField className="employee-show-item"  label="Стать" source="party.gender" choices={[
                                { id: 'MALE', name: 'чоловік' },
                                { id: 'FEMALE', name: 'жінка' }
                            ]} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Дата народження"}/>
                            <DateField className="employee-show-item"  label="Дата народження" source="party.birthDate" locales="ru-RU" />
                        </CardContent>
                    </Card>
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Верифікація</Typography>
                        <CardContent style={rowStyle}>
                            {
                                record.partyVerification?.details.dracsDeath.verificationStatus === 'NOT_VERIFIED' ?
                                    <div style={error}>
                                        <p>Увага! Персональні дані співробітника
                                            потребують перевірки:</p>
                                        <p>Зафіксовано актовий запис про смерть в державному реєстрі Міністерства Юстиції який потребує підтвердження чи спростування від працівника відділу кадрів або керівника закладу.</p>
                                        <p>Для уникнення обмеження роботи в ЕСОЗ необхідно перевірити актуальність персональних даних та оновити за необхідності.<br/>
                                            Якщо оновлення не можливе необхідно звернутись до НСЗУ для внесення змін.<br/>
                                            Якщо дані вказано відповідно до актуальних документів необхідно звернутись до ДПС або ДРАЦСГ залежно від отриманого статусу для уточнення даних про себе.</p>

                                        <PartyVerificationDeathButton {...record} />
                                    </div> :
                                    record.partyVerification?.details.drfo.verificationStatus === 'NOT_VERIFIED' ?
                                        <div style={error}>
                                            <p>Увага! Персональні дані співробітника
                                                потребують перевірки:</p>
                                            <p>РНОКПП, дата народження або ПІБ не відповідають даним в реєстрі ДПС.<br />
                                                В разі відмови співробітника від присвоєння РНОКПП (наявна відмітка або довідка) необхідно також оновити відомості про документ.</p>
                                            <p>Для уникнення обмеження роботи в ЕСОЗ необхідно перевірити актуальність персональних даних та оновити за необхідності.<br />
                                                Якщо оновлення не можливе необхідно звернутись до НСЗУ для внесення змін.<br />
                                                Якщо дані вказано відповідно до актуальних документів необхідно звернутись до ДПС або ДРАЦСГ залежно від отриманого статусу для уточнення даних про себе.</p>
                                        </div> : null
                            }
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <VerificationArrayField label="" source="partyVerification.verificationList" fullWidth={true} />
                        </CardContent>
                    </Card>
                <Card style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Документи</Typography>
                    <CardContent style={rowStyle}>
                        <DocumentArrayField label="Документи" source="party.documents" fullWidth={true}/>
                    </CardContent>
                </Card>
                <Card style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Телефони</Typography>
                    <CardContent style={rowStyle}>
                        <PhoneArrayField source="party.phones" />
                    </CardContent>
                </Card>

                <Card style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Навчальний заклад</Typography>
                    <CardContent style={rowStyle}>
                        <EducationArrayField label="Навчальний заклад" source="doctor.educations" />
                    </CardContent>
                </Card>
                <Card style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Спеціальності</Typography>
                    <CardContent style={rowStyle}>
                        <SpecialitiesArrayField label="Спеціальності" source="doctor.specialities" />
                    </CardContent>
                </Card>
                <Card style={cardStyle}>
                    <Typography variant="h6" style={{marginBottom: '0.5em'}}>Кваліфікації</Typography>
                    <CardContent style={rowStyle}>
                        <QualificationArrayField label="Кваліфікації" source="doctor.qualifications" />
                    </CardContent>
                </Card>
            </div>
    </div>
);

const EmployeeShowTitle = ({ record }) => {
    return <span>Мої співробітники: {record ?
        (record.party.lastName ? record.party.lastName + ' ' : '' ) +
        (record.party.firstName ? record.party.firstName : '') +
        (record.party.secondName ? ' ' + record.party.secondName : '') : ''
    }
    </span>;
};

export const EmployeeShow = (props) => (
    <Show
          title={<EmployeeShowTitle />}
          className="show-styles"
          {...props}
          actions={<EmployeeActions />}
    >
        <LocalEntityGrid />
    </Show>
);

export default EmployeeShow;
